import { useCallback, useEffect, useRef } from 'react';

export default ({ loading }) => {
  const previousLoading = useRef();
  const lastFocusedElementRef = useRef();

  const onItemFocus = useCallback((e) => {
    lastFocusedElementRef.current = e.target;
  }, []);

  useEffect(() => {
    const lastFocusedElement = lastFocusedElementRef.current;
    if (false === loading && true === previousLoading.current && lastFocusedElement) {
      lastFocusedElement.focus();
    }
    previousLoading.current = loading;
  }, [loading]);

  return onItemFocus;
};
